var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 37 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-3 {\n        fill: none;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    y: -134,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 37,
    height: 37
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.4,2.35c1.11,2.61,1.92,5.33,2.84,8.01.29.85-.07,1.6-.66,2.22-.61.65-1.22,1.31-1.88,1.9-.75.67-.85,1.31-.37,2.24,2.49,4.83,6.32,8.27,10.99,10.88.76.43,1.37.29,1.96-.32.64-.68,1.31-1.33,1.98-1.98.66-.63,1.47-.97,2.34-.66,2.66.96,5.41,1.69,8,2.86,1.27,1.69,1.24,4.04-.08,5.72-.68.87-1.54,1.54-2.4,2.2-.17.12-.34.23-.5.35,0,0,0-.03,0-.03-3.88,1.81-7.69,1.38-11.35-.53C13.04,30.92,6.65,24.76,2.53,16.38c-1.83-3.72-2.28-7.5-.27-11.32.74-1.07,1.51-2.1,2.6-2.85,1.68-1.16,3.98-1.1,5.53.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M36.34,22.09c-1.17-.08-1.39-.29-1.39-1.5.05-8.21-5.51-15.67-13.69-17.83-1.59-.42-3.2-.64-4.85-.6-.95.03-1.51-.33-1.4-1.38.82-1.04,1.97-.63,2.96-.54,4.65.4,8.77,2.12,12.24,5.28,3.72,3.39,5.86,7.62,6.53,12.6.12.87.13,1.76.19,2.64.04.55-.15,1-.59,1.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.31,5.11c7.04.1,12.89,5.53,13.55,12.57.04.47.11.95.11,1.42,0,.64-.23,1.17-.99,1.16-.75,0-.99-.5-.97-1.16.05-1.95-.37-3.8-1.29-5.51-2.19-4.09-5.62-6.27-10.27-6.49-.07,0-.14,0-.2,0-.74.02-1.48-.11-1.45-1.02.03-.91.79-.98,1.51-.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.78,10.16c3.98.1,7.23,3.51,7.16,7.35-.01.68-.22,1.19-.93,1.2-.65,0-.89-.46-.95-1.1-.36-3.52-2.09-5.23-5.62-5.58-.64-.06-1.11-.34-1.07-.98.06-.95.81-.94,1.41-.9Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.c9b48e0fb41cf6b249320077db6599e1.svg";
export { ForwardRef as ReactComponent };